import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import { api } from '../lib/api';
import { getAuth } from 'firebase/auth';

export default function LanguageToggle() {
  const { lang, setLang } = useLang();
  const next = lang === 'en' ? 'hi' : 'en';
  const label = lang === 'en' ? 'हिं' : 'En';

  const handleToggle = () => {
    setLang(next);
    // Sync to backend silently if logged in
    if (getAuth().currentUser) {
      api.put('/api/user/settings', { language: next }).catch(() => {});
    }
  };

  return (
    <button
      data-testid="language-toggle"
      onClick={handleToggle}
      title={lang === 'en' ? 'Switch to Hindi' : 'अंग्रेज़ी में बदलें'}
      style={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 1000,
        background: 'rgba(17,24,39,0.85)',
        border: '1px solid rgba(201,168,76,0.4)',
        color: '#C9A84C',
        borderRadius: 20,
        padding: '6px 14px',
        fontSize: 13,
        fontWeight: 600,
        cursor: 'pointer',
        backdropFilter: 'blur(8px)',
        transition: 'background 0.2s',
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {label}
    </button>
  );
}
